import React from "react"
import { css } from "@emotion/core"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons"
import { navigate } from "gatsby"

import { sessionStore } from "../../utils/customStorage"

const RESULT_PATH_KEY = "pb-result-path"

const buttonStyle = css`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 12px 20px;
  border: 0;
  border-radius: 999px;
  box-shadow: 0 3px 6px -2px rgba(0, 0, 0, 0.3);
  background: #fff;
  color: #155d91;
  font: inherit;
  font-weight: 700;
  cursor: pointer;

  &:hover,
  &:focus {
    background: #f1f1f1;
  }

  &:focus {
    outline: 3px solid rgba(31, 127, 200, 0.35);
    outline-offset: 2px;
  }
`

const parseRecommendationPath = (isEnglish, referrer) => {
  const prefix = isEnglish ? "/en/recommandation/" : "/fr/recommandation/"

  if (referrer) {
    try {
      const url = new URL(referrer, window.location.origin)
      if (
        url.origin === window.location.origin &&
        url.pathname.startsWith(prefix)
      )
        return `${url.pathname}${url.search}${url.hash}`
    } catch (error) {
      // Ignore malformed referrers.
    }
  }

  return null
}

const getRecommendationPath = isEnglish => {
  const queryReferrer = new URLSearchParams(window.location.search).get(
    "referrer"
  )
  const queryPath = parseRecommendationPath(isEnglish, queryReferrer)
  if (queryPath) return { path: queryPath, closeWindow: true }

  const documentPath = parseRecommendationPath(isEnglish, document.referrer)
  if (documentPath) return { path: documentPath, useHistory: true }

  const prefix = isEnglish ? "/en/recommandation/" : "/fr/recommandation/"
  const rememberedPath = sessionStore.getItem(RESULT_PATH_KEY)
  if (rememberedPath && rememberedPath.startsWith(prefix))
    return { path: rememberedPath, useHistory: false }

  return null
}

export const BackToResults = ({ stateProps, htmlProps, isCanvas = false }) => {
  const [pageState] = stateProps.pageContext
  const isEnglish = pageState.lang === "en-ca"
  const label = isEnglish
    ? "Back to my test results"
    : "Retourner aux résultats de mon test"

  const goBack = () => {
    if (isCanvas || typeof window === "undefined") return

    const result = getRecommendationPath(isEnglish)
    if (result && result.closeWindow) {
      window.close()
      window.setTimeout(() => {
        if (!window.closed) navigate(result.path)
      }, 100)
      return
    }

    if (result && result.useHistory) {
      window.history.back()
      return
    }

    navigate(result ? result.path : isEnglish ? "/en" : "/")
  }

  return (
    <button {...htmlProps} css={buttonStyle} type="button" onClick={goBack}>
      <FontAwesomeIcon icon={faArrowLeft} aria-hidden="true" />
      <span>{label}</span>
    </button>
  )
}

BackToResults.displayName = "BackToResults"

export const BackToResultsCanvas = props => (
  <BackToResults {...props} isCanvas />
)
BackToResultsCanvas.displayName = "BackToResultsCanvas"
